import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from 'react-router-dom';
import RegionHeading from "./../items/RegionHeading";
import DatumSmall from "./../items/DatumSmall";
import {EMPLOYMENT_NAMES, EMPLOYMENT_FIELDS, OCCUPATIONAL_FIELDS, VIEWS} from "./../../helpers/consts";
import {setTooltipDataAction} from "./../../actions/SettingsAction";

import "./MapTooltip.css";

class MapTooltip extends Component {

  constructor(props) {
    super(props);
    this.timeoutID = null;
    this.getExtraFieldSelected = this.getExtraFieldSelected.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.tooltipData && !this.props.tooltipData
    ){
      clearTimeout(this.timeoutID);
    } else if (
      (!prevProps.tooltipData && this.props.tooltipData)
      ||
      (prevProps.tooltipData && this.props.tooltipData &&
      prevProps.tooltipData.data.name !== this.props.tooltipData.data.name)
    ) {
      clearTimeout(this.timeoutID);
      this.timeoutID = setTimeout(()=>{
        this.props.setTooltipData(null);
      },2000);
    }
  }

  getExtraFieldSelected(datum){
    const {options, selectedOccupation, hashParts} = this.props;
    const selected = hashParts;
    let extraFieldSelected = false;
    let field, unit, label;
    switch (selected.view) {
      case VIEWS.OCCUPATIONAL:
        field = OCCUPATIONAL_FIELDS[options.measure_occ.key === "delta" ? `delta` : `${options.perspective_occ.key}_${options.share_occ.key}`];
        field = `${selectedOccupation.id}_${field}`;
        unit = options.measure_occ.key === "delta"? "%":options.share_occ.key === 'absolute'?'thousand':'%';
        label = options.measure_occ.key === "delta" ? "2018-30 Job change" : `${options.perspective_occ.value} occupation (${options.share_occ.key})`;
        if (field && datum[field]) {
          extraFieldSelected = {label: label, value: `${datum[field]} ${unit}`}
        }
        break;
      case VIEWS.EMPLOYMENT:
        field = EMPLOYMENT_FIELDS[`${options.perspective.key}_${options.measure.key}`];
        label = EMPLOYMENT_NAMES[`${options.perspective.key}_${options.measure.key}`];
        if (field && datum[field]) {
          extraFieldSelected = {label: `${label}`, value: `${datum[field]}%`}
        }
        break;
      case VIEWS.REGIONAL_CLUSTER:
        extraFieldSelected = {label: `Cluster Name`, value: `${datum.cluster_name}`};
        break;

      default:
        break;
    }
    return extraFieldSelected;
  }

  render() {
    const {tooltipData} = this.props;

    if (!tooltipData) return null;

    const extraFieldSelected = this.getExtraFieldSelected(tooltipData.data);

    return (
      <div id="fow-tooltip" style={{left: tooltipData.x, top: tooltipData.y}}>
        <div className="fow-row">
          <div className="fow-col-1 fow-heading-col">
            {tooltipData.direction === 'L' &&
              <div className="fow-tooltip-arrow-l">
                <div className="fow-tooltip-arrow-inner-l" />
              </div>
            }
            {tooltipData.direction === 'R' &&
              <div className="fow-tooltip-arrow-r">
                <div className="fow-tooltip-arrow-inner-r" />
              </div>
            }
            <RegionHeading
              nuts3={tooltipData.data.name}
              cluster={tooltipData.data.cluster_name}
              metro={tooltipData.data.metro_name}
              country={tooltipData.data.country_name} />
          </div>
        </div>
        <div className="fow-row">
          <div className="fow-col-1-2">
            {extraFieldSelected && extraFieldSelected.value &&
              <DatumSmall label={extraFieldSelected.label} value={extraFieldSelected.value} />
            }
          </div>
          <div className="fow-col-1-2">
            <DatumSmall label="Region Type" value={tooltipData.data.urban_name} />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    hashParts: state.settings.hashParts,
    tooltipData: state.settings.tooltipData,
    options: state.settings.switch,
    selectedOccupation: state.settings.map["Occupations"]
  };
};
const mapDispatchToProps = dispatch => ({
  setTooltipData: data => dispatch(setTooltipDataAction(data)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MapTooltip));
